import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import NavBar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
// import Portfolio from './pages/Portfolio';
import Posts from './pages/Posts';
// import Resume from './pages/Resume';

function App() {
  return (
    <Router>
      <div className="App">
        <Sidebar />
        <div className="content">
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/portfolio" element={<Portfolio />} /> */}
            <Route path="/posts" element={<Posts />} />
            {/* <Route path="/resume" element={<Resume />} /> */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
